import * as api from "../api";
import {
  CREATEUSER,
  DELETEUSER,
  UPDATEUSER,
  FETCHUSERS,
  FETCHUSER,
} from "../constants/actionTypes";
import { message } from "antd";

export const getUsers = (storeId, role) => async (dispatch) => {
  try {
    const { data } = await api.getUsers(storeId, role);
    dispatch({ type: FETCHUSERS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getUser = (id) => async (dispatch) => {
  try {
    const { data } = await api.getUser(id);
    dispatch({ type: FETCHUSER, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const createUser =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createUser(formData);
      dispatch({ type: CREATEUSER, data });
      if (data) {
        setLoadingButton(false);
        history("/customers");
        message.success("Customer added successfully!");
      }
    } catch (error) {
      if (error) {
        console.log(error);
        setLoadingButton(false);
        message.error(error?.response?.data);
      }
    }
  };

export const updateUser =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateUser(id, formData);
      dispatch({ type: UPDATEUSER, payload: data });
      if (data?._id) {
        setLoadingButton(false);
        history("/customers");
        message.success("Profile updated successfully");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error);
        message.error(
          error?.response?.data?.message
            ? error?.response?.data?.message
            : "Network Error"
        );
      }
    }
  };

export const deleteUser = (id, history) => async (dispatch) => {
  try {
    const response = await api.deleteUser(id);
    dispatch({ type: DELETEUSER, payload: id });
    if (response?.data?.success === true) {
      history("/customers");
      message.success("Customer deleted successfully");
    }
  } catch (error) {
    console.log(error);
    message.error(error?.response?.data);
  }
};
